/* eslint-disable @typescript-eslint/no-explicit-any */
import classNames from 'classnames'
import type { FC } from 'react'
import React, { Fragment, useRef } from 'react'

import { insertBR } from './utils'
import extractStringNodes from '../../utils/extract-string-nodes'
import makeId from '../../utils/make-id'
import type { TextProps } from '../_primitives/text'
import Text from '../_primitives/text'
import Expander from '../text-container/expander'

const TextFormatter: FC<TextProps> = props => {
  const { id, key, className, children, as: asProps = 'p', ...rest } = props
  const identifierRef = useRef<string>(id || makeId())
  const expander = React.Children.toArray(children).filter(
    (i: any) => i && i.type === Expander
  )
  const contentList = extractStringNodes(
    React.Children.toArray(children).filter(i => typeof i === 'string')
  )

  const _text = insertBR(`${contentList}`)

  const paragraphs = _text.split('<br>').filter(i => !!i)
  return (
    <Text
      key={key || `${identifierRef.current}`}
      className={classNames('csg-tui-text-formatter', className)}
      {...rest}
    >
      {paragraphs.map((v, i) => (
        <Fragment key={`${identifierRef.current}-${i}`}>
          <Text as={asProps}>
            {`${v}${
              i === paragraphs.length - 1 && expander.length > 0 ? ' ' : ''
            }`}
            {i === paragraphs.length - 1 ? expander : ''}
          </Text>
          {asProps === 'span' && <br />}
        </Fragment>
      ))}
    </Text>
  )
}

export default TextFormatter
